import { type UUID } from '~/types/common';

import { useQueryCompaniesInfinite } from '~/data/company';

import { MultiItemsManager } from './MultiItemsManager';

type P = {
  readonly isCreatingNewEntity?: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly parentOrganizationalUnitId?: UUID;
};

export const MultiItemsManagerCompanies = ({
  isCreatingNewEntity = false,
  isDisabled = false,
  label = 'Firmen',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  parentOrganizationalUnitId,
}: P) => {
  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQueryCompaniesInfinite({
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQueryCompaniesInfinite({
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
    />
  );
};
